"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const imageGenerationToolRegistry = {
  generateImage: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./generate-image").then(({ GenerateImageToolView }) => ({
        default: GenerateImageToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
